// src/components2/Report/BarChart.js
// 動的バーチャートコンポーネント
// 応募者データを棒グラフに変換します
import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: ['chartData', 'options'],
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}



// WEBPACK FOOTER //
// ./src/components2/Report/BarChart.js